<template>
    <div>
        <transition name="modal" v-if="carregando">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <img src="../../assets/imagens/loadingSpinner.gif" alt="Roda de carregamento girando">
                        <label>Aguarde. Carregando.</label>
                    </div>
                </div>
            </div>
        </transition>
        <div v-else>
            <div v-if="erro">
                <div>
                    <SemPermissao></SemPermissao>
                </div>
            </div>
            <template v-if="!erro">
                <PerguntaForm :pergunta="pergunta" />
            </template>
        </div>
    </div>
</template>

<script>

    import PerguntaForm from "../../components/perguntas/PerguntaForm.vue"
    import PerguntaApi from "../../services/PerguntaApi"
    import SemPermissao from "../SemPermissao.vue"
    import metaDados from "../../helpers/metaDados";

    export default {
        name: "PerguntaEdit",
        metaInfo() {
            if (!this.pergunta) {
                return {};
            }
            let title = this.pergunta.texto;
            const description = this.pergunta.texto;

            return {
                title,
                titleTemplate: "Editar %s - Casa Civil do Estado de Goiás",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        property: "description",
                        content: description,
                    },
                    {
                        vmid: "og:description",
                        property: "og:description",
                        content: description,
                    },
                    {
                        vmid: "og:title",
                        property: "og:title",
                        content: `${title} - Casa Civil do Estado de Goiás`,
                    },
                    ...metaDados(this.$route),
                ],
            };
        },
        data() {
            return {
                carregando: true,
                erro: false,
                pergunta: null,
            };
        },
        components: {
            SemPermissao,
            PerguntaForm,
        },
        created() {
            this.perguntaApi = new PerguntaApi();
            this.carregarPergunta();
        },
        watch: {
            $route: function (to, from) {
                if (to.params.id != from.params.id) {
                    this.carregarPergunta();
                }
            },
        },
        methods: {
            carregarPergunta: async function () {
                try {
                    this.carregando = true;
                    this.erro = false;

                    if (this.perguntaApi.cancelTokens.getPergunta) {
                        this.perguntaApi.cancelTokens.getPergunta.cancel();
                    }

                    const dadosPergunta = await this.perguntaApi.getPergunta(
                        this.$route.params.id
                    );
                    this.pergunta = dadosPergunta;

                    this.carregando = false;
                } catch (err) {
                    if (this.perguntaApi.isCancel(err)) {
                        return;
                    }
                    console.log(err);

                    this.erro = true;
                    this.carregando = false;
                    this.pergunta = null;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
/* Seus estilos podem ser mantidos aqui */
</style>